const translations = {
    de: {
        cta: 'Zum Abspielen akzeptiere unsere ',
        cookies: 'Cookie-Richtlinien',
        accept: 'Cookies erlauben',
    },
    en: {
        cta: 'To watch this please accept our ',
        cookies: 'cookie policies',
        accept: 'Allow cookies',
    },
};

export default translations;
